<template>
  <div v-if="categories && categories.length > 0" class="c-startpage-teaser-category flex flex-col gap-4">
    <div>
      <h2 class="text-2xl font-bold">
        <template v-if="config?.headlines && config?.headlines['Top-Kategorien'] && config?.headlines['Top-Kategorien'] != ''">
          {{ config?.headlines['Top-Kategorien'] }}
        </template>
        <template v-else>
          Unsere Top-Kategorien
        </template>
      </h2>
    </div>
    <div class="teaser-category grid grid-cols-2 lg:hidden">
      <NuxtLink
        v-for="category in categories" :key="category"
        class="item"
        :to="category.url"
      >
        <div class="image"><img :src="category.img.url" :alt="category.img.alt"></div>
        <div
          class="name w-full text-center text-ellipsis overflow-hidden px-4"
          v-text="category.title"
        />
      </NuxtLink>
    </div>    
    <div class="hidden lg:block">
      <template v-if="categories.length > 6">
        <NuxtCarousel v-bind="carouselConfig" class="tiles">
          <NuxtSlide v-for="category in categories" :key="category">
            <BasicBtErrorBoundary>
              <div class="teaser-category flex flex-col">
                <NuxtLink
                  class="item border-secondary-dark"
                  :to="category.url"
                >
                  <div class="image"><img :src="category.img.url" :alt="category.img.alt"></div>
                  <div
                    class="name w-full text-center text-ellipsis overflow-hidden px-4"
                    v-text="category.title"
                  />
                </NuxtLink>
              </div>
            </BasicBtErrorBoundary>
          </NuxtSlide>
          <template #addons>
            <NuxtNavigation />
          </template>
        </NuxtCarousel> 
      </template>
      <template v-else>
        <div class="grid grid-cols-2 lg:grid-cols-6 gap-4">
          <template v-for="category in categories" :key="category">
            <div v-if="category.img.alt" class="teaser-category flex flex-col">
              <NuxtLink
                class="item border-secondary-dark"
                :to="category.url"
              >
                <div class="image"><img :src="category.img.url" :alt="category.img.alt"></div>
                <div
                  class="name w-full text-center text-ellipsis overflow-hidden px-4"
                  v-text="category.title"
                />
              </NuxtLink>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
interface Category {
  title: string;
  url: string;
  img: string;
}

interface StartpageConfig {
  layout?: string;
  headlines?: Record<string, string>;
  categories?: Category[];
  value: { categories:string },
}

const config = inject("startpageConfig") as StartpageConfig | undefined;
const categories = ref();

onNuxtReady(() => {
  watchEffect(() => {
    watch(useCurrentStore(), () => {
      initSlider();
    }, { immediate: true });
  });
});

async function initSlider() {
  categories.value = config?.value?.categories ?? '';
}

const carouselConfig = {
  itemsToShow: 1.5,
  gap: 24,
  height: 240,
  breakpointMode: 'carousel',
  snapAlign: 'center',
  wrapAround: true,
  breakpoints: {
    1080: {
      itemsToShow: 5.5,
      snapAlign: 'start',
    },
  },
} as const;
</script>
<style scoped lang="postcss">
.teaser-category {
  @apply overflow-hidden items-center font-bold gap-2 lg:gap-6 h-full;
  
}
.item {
  @apply flex flex-col items-center justify-between h-full border rounded-3xl bg-white;
  & img {
    @apply max-h-[75%];
  }
  & .image {
    @apply grow items-center flex justify-center;
  }
  & .name {
    @apply pb-4;
  }
}
</style>
